/* Ported from src/components/ProductGrid.tsx — scroll-reveal stagger on cards. */
(function () {
  function init(root) {
    if (typeof window.gsap === 'undefined') return;
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

    root.querySelectorAll('.oblivion-product-card-wrap').forEach(function (card) {
      gsap.fromTo(
        card,
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: { trigger: card, start: 'top 85%' },
        }
      );
    });
  }

  function boot() {
    document.querySelectorAll('[data-oblivion-product-grid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
